import React, { useEffect } from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import SubFooter from "../SubFooter";
import OurTeam from "./OurTeam";
import Section1 from "./Section1";
import ConpanyOverview from "./ConpanyOverview";
import HowItWorks from "./HowItWorks";
import CompanyLogos from "./CompanyLogos";
import Introduction from "./Introduction";

function LandingPage() {
  const title = "Why Wait?";
  const subTitle =
    "We designed Souqh to help eliminate the stress in the home journey.";
  const btnText = "Sign up now for free!";
  const redirectUrl = "https://app.souqh.ca/";
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const xlUp = useMediaQuery(theme.breakpoints.up("xl"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));

  const commonPadding = lgUp ? "0px 10%" : "0px 2%";

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        top: smUp ? (lgUp ? 50 : 40) : 50,
        marginBottom: 105,
      }}
    >
      <Introduction 
      smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}></Introduction>
      <HowItWorks
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}
      />
      <Section1
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}
      />

      <OurTeam
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}
      />

      <ConpanyOverview
        smUp={smUp}
        mdUp={mdUp}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}
      />

      <CompanyLogos
        title={"You are in good company"}
        smUp={smUp}
        mdUp={mdUp}
        lgUp={lgUp}
        xlUp={xlUp}
        commonPadding={commonPadding}
      />

      <SubFooter
        title={title}
        subTitle={subTitle}
        btnText={btnText}
        redirectUrl={redirectUrl}
      />
    </div>
  );
}

export default LandingPage;
